import { Collapsible } from "@/components/ui";
import { type Control, Controller } from "react-hook-form";
import {
  AOEQuestionItemControl,
  type AOEQuestionnaire,
} from "../../network/useRetrieveAOEForOrder";
import { CheckboxQuestion } from "./FormComponents/CheckboxQuestion";
import { DateQuestion } from "./FormComponents/DateQuestion";
import { FreetextQuestion } from "./FormComponents/FreetextQuestion";
import { FreetextableSelectQuestion } from "./FormComponents/FreetextableSelectQuestion";
import { MultiSelectQuestion } from "./FormComponents/MultiSelectQuestion";
import { RadioQuestion } from "./FormComponents/RadioQuestion";
import { SelectQuestion } from "./FormComponents/SelectQuestion";
import type { AOEFormSchema } from "./schemas";

export const TestQuestionsForm = ({
  questionnaire,
  control,
  disabled,
}: {
  questionnaire: AOEQuestionnaire;
  control: Control<AOEFormSchema, string>;
  disabled: boolean;
}) => {
  return (
    <Collapsible title={questionnaire.testName} headerSize="sm" defaultOpen>
      <div className="grid grid-cols-2 gap-2">
        {questionnaire.questions.map((question) => (
          <Controller
            key={`${questionnaire.questionnaireResponseId}-${question.linkId}`}
            control={control}
            name={`questionnaires.${questionnaire.questionnaireResponseId}.${question.linkId}`}
            render={({ field, fieldState }) => {
              switch (question.itemControl) {
                case AOEQuestionItemControl.TEXT:
                  return (
                    <FreetextQuestion
                      question={question}
                      field={field}
                      fieldState={fieldState}
                      disabled={disabled}
                    />
                  );
                case AOEQuestionItemControl.CHECKBOX:
                  return (
                    <CheckboxQuestion
                      question={question}
                      field={field}
                      fieldState={fieldState}
                      disabled={disabled}
                    />
                  );
                case AOEQuestionItemControl.RADIO:
                  return (
                    <RadioQuestion
                      question={question}
                      field={field}
                      fieldState={fieldState}
                      disabled={disabled}
                    />
                  );
                case AOEQuestionItemControl.DROPDOWN:
                  return (
                    <SelectQuestion
                      question={question}
                      field={field}
                      fieldState={fieldState}
                      disabled={disabled}
                    />
                  );
                case AOEQuestionItemControl.MULTISELECT:
                  return (
                    <MultiSelectQuestion
                      question={question}
                      field={field}
                      fieldState={fieldState}
                      disabled={disabled}
                    />
                  );
                case AOEQuestionItemControl.DATE:
                  return (
                    <DateQuestion
                      question={question}
                      field={field}
                      fieldState={fieldState}
                      disabled={disabled}
                    />
                  );
                case AOEQuestionItemControl.EDITABLE_DROPDOWN:
                  return (
                    <FreetextableSelectQuestion
                      question={question}
                      field={field}
                      fieldState={fieldState}
                      disabled={disabled}
                    />
                  );
                default:
                  return (
                    <FreetextQuestion
                      question={question}
                      field={field}
                      fieldState={fieldState}
                      disabled={disabled}
                    />
                  );
              }
            }}
          />
        ))}
      </div>
    </Collapsible>
  );
};
